import template from './saveDialog.html';
import controller from './saveDialog.controller';
import './saveDialog.scss';

let saveDialogComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller,
  controllerAs: 'vm'
};

export default saveDialogComponent;



// WEBPACK FOOTER //
// ./client/app/common/saveDialog/saveDialog.component.js